// This Privileges list created from the vault team Excel
export const PRIVILEGES = {
  VIEW_MESSAGING_AVAILABILITY_INFO: '1740',
  SKILL_CHATS: '9',
  VIEW_AGENT_LIST: '1574',
  VIEW_ALL_CHATS: '10',
  VIEW_MESSAGING_SURVEYS: '1754',
  VIEW_CAMPAIGN_MODULE: '1500',
  VIEW_USERS_MODULE: '1501',
  SET_MANUAL_SLA: '1741',
  SEND_FILES_FROM_CUSTOM_WIDGET: '1777',
  UPDATE_CONSUMER_PROFILE_VIA_API: '1750',
  VIEW_SECURE_FORMS: '1558',
  VIEW_HISTORY_SECURE_FORMS: '1571',
  GENERATE_SECURE_FORM_TOKEN: '1728',
  TRANSFER_TO_OFFLINE_AGENT: '1768',
  TRANSFER_TO_AWAY_AGENT: '1767',
  TRANSFER_TO_ONLINE_AND_BACK_SOON_AGENT: '1766',
  JOIN_CONVERSATION_PRIVILEGE: '13',
  HAS_AGENT_OR_AGENT_MANAGER_PROFILE: '1561',
  VIEW_AGENT_WORKSPACE: '1786',
  TAKEOVER: '1731',
  MESSAGING_HISTORY_PRIVILEGE: '1713',
  VIEW_ACTIVE_CONNECTIONS: '1734',
  ANSWERING_SERVICE_AGENT: '1764',
  SEND_FILES_FROM_LOCAL_SYSTEM: '1771',
  FAAS_INVOKE: '1772',
  VIEW_SMART_SUGGESTIONS: '1793',
  VIEW_AUTOCOMPLETE: '1794',
  VIEW_SMART_COMPOSE: '1860',
  PROVIDE_FEEDBACK_ON_SUGGESTION_OR_AUTOCOMPLETE: '1795',
  VIEW_AGENT_SURVEY: '1798',
  SUBMIT_AGENT_SURVEY: '1799',
  HANDLE_INTENT_ANNOTATIONS: '1852',
  VIEW_ALL_TASKS: '1853',
  HANDLE_FALSE_RESPONSES: '1868',
  RETURN_CONVERSATIONS_TO_THE_QUEUE: '1890',
  VIEW_SKILL_TRANSFER_EVENTS_IN_TRANSCRIPT: '1893',
  VIEW_AGENT_TRANSFER_EVENTS_IN_TRANSCRIPT: '1894',
  VIEW_BACK_TO_QUEUE_EVENTS_IN_TRANSCRIPT: '1895',
  VIEW_JOIN_EVENTS_IN_TRANSCRIPT: '1896',
  VIEW_TAKEOVER_EVENTS_IN_TRANSCRIPT: '1897',
};

export const SESSION_SETTINGS = {
  AUTO_ACCEPT: 'messaging.routing.autoaccept',
  LANGUAGE: 'le.general.language',
  RECENTLY_CLOSED_CONVERSATIONS_DAYS: 'le.agent.recentlyClosedConversationDays',
  HOUR_FORMAT: 'le.agent.hourFormat',
  DISABLE_EMOJIS: 'le.agent.chatInput.disableIconsForMessaging',
  DISABLE_IFRAME_SANDBOX: 'disable.custom.widget.iframe.sandbox',
  DEFAULT_SUPPORTED_LANGUAGE: 'le.site.defaultSupportedLanguage',
  SUPPORTED_LANGUAGES: 'le.site.supportedLanguages',
  BLOCK_CONSUMER_NAME: 'le.agent.block.visitor.name',
  SUPPORT_UNAUTH_SDES: 'le.agent.messaging.sdes',
  SHOW_NEW_AGENT_WORKSPACE: 'le.agent.messaging.showEnhancedAgentWorkspace',
  ACD_MANUAL_SLA_AUTO_FOCUS_CONVERSATION: 'messaging.ACD.manual.autoFocusConversation',
  FILE_SHARING_BLUR_ALL_CONVERSATION_IMAGES: 'messaging.file.sharing.blurAllConversationImages',
  BLUR_CONSUMER_THUMBNAILS_FROM_BACKEND_ENABLED: 'messaging.file.sharing.blurThumbnails',
  FILE_SHARING_IMAGE_PREVIEW_SIZE: 'messaging.agent.photo.size',
  FILE_SHARING_IS_ENABLED_FOR_AGENT: 'messaging.agent.file.sharing.enabled',
  FILE_SHARING_IS_ENABLED: 'messaging.file.sharing.enabled',
  AUDIO_SHARING_IS_ENABLED: 'messaging.audio.sharing.enabled',
  NEW_AGENT_WORKSPACE_LPA: 'le.agent.messaging.newAgentWorkspaceForLPA',
  ALLOW_MICROPHONE_CAMERA: 'le.agent.widgetSdk.allowMicrophoneCamera',
  PREDEFINED_CONTENT_SHOW_TITLE_ONLY: 'le.agent.messaging.pdc.show.title.only',
  SHOW_AUTH_INDICATOR_FOR_CONNECTOR: 'le.newAgentWorkspace.showAuthIndicatorForConnectors',
  IDLE_TIME: 'le.agent.messaging.conversationIdleTime.minutes',
  SMART_SUGGESTIONS_SETTINGS: 'le.suggestions',
  ACCOUNT_INFO: 'le.site.accountInfo',
  SMART_CAPACITY_DEFAULT: 'messaging.smart.capacity.fresh.agent.pending.time.sec',
  SMART_CAPACITY_PER_SKILL: 'messaging.smart.capacity.per.skill.definition',
  DEACTIVATE_SHORTCUTS: 'le.general.deactivateShortcuts',
  SHOW_CONVERSATION_SOURCE_IN_LIST: 'le.newAgentWorkspace.showConversationSourceInList',
  ALERT_ON_PASTE: 'le.agent.alertOnPaste',
  DISABLED_NON_RESPONSE_STATE: 'messaging.connection.nonresponsivestate.disabled',
  CUSTOM_RINGS_ENABLED: 'le.ui.custom.rings.enabled',
  HIDE_HISTORY_CONVERSATIONS_IN_TRANSCRIPT_FOR_SKILLS: 'messaging.hide.history.conversations.in.transcript.for.skills',
  SAME_SKILL_TRANSFER_PREVENTION: 'messaging.transferBySkill.preventTransferToSameSkill',
  SHOW_READ_INDICATION_BELOW_MESSAGE: 'le.agent.messaging.show.read.indication.below.message',
  AGENT_NOT_TYPING_TIMEOUT: 'le.site.messaging.agentNotTypingTimeout',
  CUSTOM_WIDGET_SEND_ERROR_ON_GET_NULL_SUB_KEY: 'le.agent.widgetSdk.sendErrorOnGetSubKeyOfNull',
  SOCIAL_MESSAGING_FACEBOOK_ENABLED: 'socialmessaging.ui.datasource.enabled',
  MASKED_RECENTLY_CLOSED_CONVERSATION_TRANSCRIPT_MINUTES: 'le.agent.maskedRecentlyClosedConversationTranscriptMinutes',
  MASKED_RECENTLY_CLOSED_CONVERSATION_TRANSCRIPT: 'le.agent.fetchRecentlyClosedMaskedConversationTranscript',
  FETCH_ONGOING_CONVERSATION_INTERVAL: 'le.ui.fetchOngoingConversationDataInterval',
  FETCH_CLOSED_CONVERSATION_INTERVAL: 'le.ui.fetchClosedConversationDataInterval',
  NEUTRAL_COUNTRY_LABEL: 'le.site.neutralCountryLabel',
  PERFORMANCE_LOG_INTERVAL: 'le.site.performanceLogInterval.minutes',
  PHASE: 'le.site.leui.phase',
  GET_CUSTOM_WIDGET_TIMEOUT: 'le.ui.customWidgetsTimeoutSeconds',
  DISPLAY_SECURE_FORMS_SENT_BY_BOTS: 'messaging.display.secure.form.sent.by.bots',
  ADD_REPLACE_SMART_REPLY_CONTROLS: 'le.suggestions.smartReply.addReplaceSmartReplyControls',
  USERS_THAT_NEEDS_ACCESSIBILITY: 'le.ui.a11y.usersWithFocusOutline',
  STEP_UP_NOTIFICATION: 'messaging.stepUpNotifications',
  FILTER_SECURE_FORM: 'messaging.FilterSecureForms',
  SHOW_JOURNEY_WIDGET: 'messaging.journey.widget',
  ALLOW_SENDING_BOT_MESSAGES_TO_SMART_ASSIST: 'le.suggestions.allowSendingBotMessagesToSmartAssist',
};

export const FEATURES = {
  ASYNC_MESSAGING: 'Common.Async_Messaging',
  AGENT_WORKSPACE_FEATURE: 'Messaging.New_agent_workspace',
  ENFORCE_NEW_AGENT_WORKSPACE: 'LEUI.Enforce_New_Agent_Workspace',
  BLOCK_NEW_AGENT_WORKSPACE: 'LEUI.Block_New_Agent_Workspace',
  VIEW_MESSAGING_SECURE_FORM: 'LEUI.Messaging_Secure_Form',
  VIEW_SECURE_FORM_HISTORY: 'Reports.EngagementHistory_PCI_Data_Display',
  GENERATE_SECURE_FORM_TOKEN: 'Reports.GenerateSecureFormToken',
  TRANSFER_TO_AGENT: 'Messaging.Transfer_To_Agent',
  TAKEOVER: 'Common.Takeover_Conversation',
  MESSAGING_SURVEY: 'Common.Messaging_Survey',
  AGENT_GROUPS: 'Common.AgentGroups',
  CAN_SHARE_ADDITIONAL_FILE_TYPES: 'Messaging.Agent_File_Sharing_v2',
  FAAS: 'FaaS.FaaS',
  CONTACT_CENTER: 'Common.Messaging_Cross_Account_Contact_Center',
  ANSWERING_SERVICE: 'Common.Answering_Service',
  AGENT_SET_CONSUMER_PROFILE: 'Messaging.AgentSetConsumerProfile',
  SOCIAL_CONNECT: 'SocialConnect.Enabled',
  CAN_USE_SMART_SUGGESTIONS: 'Messaging.Smart_Suggestions',
  CAN_SEND_HYPERLINKS: 'Messaging.Agent_Link_Sending',
  CONVERSATION_SUMMARY_WIDGET: 'Messaging.Conversation_Summary_Widget',
  AGENT_SURVEY: 'Messaging.Agent_Survey',
  RICH_CONTENT: 'Common.RichContent',
  SEND_PRIVATE_MESSAGE: 'Messaging.Private_Messages',
  // When this feature is on, there is no need to update agent status in UMS
  PREVENT_UPDATE_AGENT_STATUS_AT_UMS: 'Messaging.Set_Agent_State_By_Facts',
  AUTHENTICATED_CHAT: 'Common.Authenticated_Chat',
  HANDLE_INTENT_ANNOTATIONS: 'Tasks.Handle_Intent_Annotaitons',
  HANDLE_FALSE_RESPONSES: 'Tasks.Handle_False_Responses',
  USE_CUSTOM_RINGS: 'LEUI.Use_Custom_Rings',
  BAM_ENABLED: 'LEUI.BAM_Enabled',
  AHT_ENABLED: 'Common.WorkforceManagement_AHT',
  AI_ASSIST_WIDGET: 'Common.AI_Assist_Widget',
  RICH_TEXT_FORMATTING: 'Messaging.Rich_Text_Formatting',
  SEND_CONSUMER_MESSAGE_METADATA: 'Messaging.Send_Consumer_Message_Metadata',
  IS_CTRL_ENTER_FEATURE_ENABLED: 'Messaging.isCtrlEnterFeatureEnabled',
  CONSUMER_MESSAGE_CHANNEL_INDICATOR: 'Messaging.Consumer_Message_Channel_Indicator',
  ALLOW_LINK_RENDERING: 'Messaging.AllowLinksRendering',
  WIDGET_TWITTER_ENABLED: 'SocialMessaging.Widget_Twitter_Enabled',
  WIDGET_FACEBOOK_ENABLED: 'SocialMessaging.Widget_Facebook_Enabled',
  CONTROL_RETURN_TO_QUEUE: 'Common.ControlReturnToQueue',
  SHOW_CONVERSATION_EVENTS_IN_TRANSCRIPT: 'Messaging.Conversation_Events_In_Transcript',
  DISPLAY_MCS_IN_CONVERSATION: 'Messaging.Display_MCS_In_Conversation',
};

export const FEATURE_FLAGS = {
  SHOW_INLINE_RECOMMENDED_ACTIONS: { name: 'showInlineRecommendedActions', default: true },
  SHOW_AGENT_SURVEY: { name: 'showAgentSurvey', default: true },
  SEPARATED_OPEN_CLOSED_SUBSCRIPTIONS: { name: 'separatedOpenClosedSubscriptions', default: true },
  SEND_PRIVATE_MESSAGE: { name: 'sendPrivateMessage', default: true },
  SHOW_PAGE_NAVIGATION_WIDGET: { name: 'showPageNavigationWidget', default: true },
  SHOULD_LOG_THROTTLED_BY_SERVER: { name: 'shouldLogThrottledByServer', default: true },
  SMART_COMPOSE_PERMISSION_FLAG: { name: 'smartComposePermissionFlag', default: true },
  SEND_LATEST_AGENT_ID: { name: 'sendLatestAgentId', default: true },
  ADD_CONVERSATION_CAPPING_CONFIGURATION: { name: 'addConversationCappingConfiguration', default: true },
  ALLOW_LAST_MESSAGE_REQUEST: { name: 'allowLastMessageRequest', default: true },
  ADD_FETCH_CONVERSATION_DATA_INTERVAL: { name: 'addFetchConversationDataInterval', default: true },
  USE_EXPONENTIAL_RETRY_FOR_MIA: { name: 'useExponentialRetryForMIA', default: true }, // we take a feature flag via window, not from store. Here we want to leave a flag just to remember the name.
  HAS_MESSAGING_LAZY_LOAD_MESSAGES: { name: 'hasMessagingLazyLoadMessages', default: false },
  TOGGLE_TWITTER_CHARACTER_LIMIT: { name: 'toggleTwitterCharacterLimit', default: false },
  DISABLE_KIBANA_LOG_FETCH_SURVEY: { name: 'disableKibanaLogFetchSurvey', default: false },
  SHOW_EXTEND_INPUT_AREA: { name: 'showExtendInputArea', default: false },
  RICH_FORMATTING_TOOLBAR: { name: 'richFormattingToolbar', default: false },
  SEARCH_BY_CONSUMER_INITIAL_RETRY_DELAY: { name: 'searchByConsumerInitialRetryDelay', default: 15 },
  HISTORY_CONVERSATIONS_CAPPING_VALUE: { name: 'historyConversationsCappingValue', default: 1 },
  SUBMIT_RICH_TEXT_WITH_CTRL_ENTER: { name: 'submitRichTextWithCtrlEnter', default: false },
  STOP_AC_CAMPAIGNS_RETRY_MECHANISM: { name: 'stopAcCampaignsRetryMechanism', default: false },
  HAS_LATEST_AGENT_IDS_FILTER: { name: 'hasLatestAgentIdsFilter', default: false },
  HAS_LATEST_SKILL_IDS_FILTER: { name: 'hasLatestSkillIdsFilter', default: false },
  HAS_VISITOR_NAME_FILTER: { name: 'hasVisitorNameFilter', default: false },
  CONSUMER_MESSAGE_CHANNEL_INDICATOR: { name: 'consumerMessageChannelIndicator', default: false },
  HAS_USED_SITE_SETTING_CUSTOM_WIDGET_TIMEOUT: { name: 'hasUsedSiteSettingCustomWidgetTimeout', default: false },
  SHOULD_DISPLAY_SECURE_FORMS_SENT_BY_BOTS: { name: 'shouldDisplaySecureFormsSentByBots', default: true },
  SHOW_ADD_REPLACE_SMART_REPLY_CONTROLS: { name: 'showAddReplaceSmartReplyControls', default: true },
  RENDER_LINK_IN_WORKSPACE: { name: 'RenderLinksInTheWorkspace', default: false },
  SOCIAL_TWITTER_FACEBOOK_WIDGET_ENABLED: { name: 'socialTwitterFacebookWidgetEnabled', default: false },
  STEP_UP_NOTIFICATION: { name: 'stepUpNotification', default: false },
  SORT_SECURE_FORM: { name: 'SortSecureForm', default: false },
  SORT_PAGE_NAVIGATION: { name: 'SortPageNavigation', default: false },
  ALLOW_CONTROLLING_RETURN_TO_QUEUE: { name: 'allowControllingReturnToQueue', default: false },
  USE_NEW_API_TO_FILTER_SECURE_FORMS: { name: 'UseNewAPItoFilterSecureForms', default: false },
  ENABLE_WHATSAPP_PRODUCT_MESSAGE: { name: 'enableWhatsappProductMessage', default: false },
  SHOW_CONVERSATION_EVENTS_IN_TRANSCRIPT: { name: 'showConversationEventsInTranscript', default: true },
  SHOW_ABC_FORM_MESSAGE: { name: 'showAbcFormMessage', default: false },
  ENABLE_FACEBOOK_DELETE_MODERATION: { name: 'enableFacebookDeleteModeration', default: false },
  ENABLE_FACEBOOK_HIDE_UNHIDE_MODERATION: { name: 'enableFacebookHideUnhideModeration', default: false },
  ENABLE_INSTAGRAM_DELETE_MODERATION: { name: 'enableInstagramDeleteModeration', default: false },
  ENABLE_INSTAGRAM_HIDE_UNHIDE_MODERATION: { name: 'enableInstagramHideUnhideModeration', default: false },
  SMART_COMPOSE_SELECTED_KEY_FEEDBACK: { name: 'SmartComposeSelectedKeyFeedback', default: false },
  SHOW_SECURE_FORM_SUBMISSION_IFRAME: { name: 'showSecureFormSubmissionIFrame', default: true },
  AGENT_SMART_ASSIST_V2: { name: 'AgentSmartAssistV2', default: false },
  ENABLE_FETCH_PAST_TWILIO_CONV_AFTER_TELNYX_MIGRATION: { name: 'enableFetchPastTwilioConvAfterTelnyxMigration', default: true },
  AGENT_SMART_ASSIST_MULTIPLE_MODELS: { name: 'AgentSmartAssistMultipleModels', default: false },
};

export const LAUNCH_DARKLY_ENVIRONMENTS = {
  LD_CLIENT_SITE_ID: 'ldClientSideId',
};

export const ACCOUNT_VERTICAL = {
  AUTOMOTIVE: 'automotive',
};

export const AUTOCOMPLETE_MODES = {
  SINGLE: 'single',
  MULTI: 'multi',
  BOTH: 'both',
};

export const ROLE_TYPES = {
  1: 'Administrator',
  2: 'Agent',
  3: 'Agent Manager',
  4: 'Campaign Manager',
};
